<template>
	<div class="city">
		<p class="clearfix btn">
			<span class="fl" @click="isNo">取消</span>
			<span class="fr" @click="isOk" >确定</span>
		</p>
		<mt-picker :slots="slots" valueKey="region_name" @change="onValuesChange"></mt-picker>
	</div>
</template>

<script>
import axios from 'axios';
import config from '../../common/config.js';

export default {
	name: 'City',
	data() {
	    return {
	    	province: [],
	    	city: [],
	    	area: [],
	    	provinceName: null,
	    	cityName: null,
	    	areaName: null,
		    slots: [
		        {
			        flex: 1,
			        values: this.province,
			        className: 'slot1',
			        textAlign: 'right'
				}, {
		         	values: this.city,
		          	className: 'slot2'
		        }, {
			        flex: 1,
			        values: this.area,
			        className: 'slot3',
			        textAlign: 'left'
		        }
		    ]
	    };
	},
	props: ['success', 'remove', 'value'],
	methods: {
		getCity2(data) {
			return axios.get(config.EXAPI + 'api/region/index', data);
		},
		isOk() {
			if( this.provinceName != undefined && this.cityName != undefined ) {
				var str = [this.provinceName, this.cityName, this.areaName];
        		this.success && this.success(str);
			}
		},
		isNo() {
			this.remove && this.remove();
		},
		onValuesChange(picker, values) {

			if(this.provinceName  !== picker.getSlotValue(0) && picker.getSlotValue(0) != undefined) {
				this.city = picker.getSlotValue(0).children;
				this.slots[1].values = this.city;
				this.provinceName = picker.getSlotValue(0);
			}

			if(this.cityName  !== picker.getSlotValue(1) && picker.getSlotValue(1) != undefined) {
				this.area = picker.getSlotValue(1).children;
				this.slots[2].values = this.area;
				this.cityName = picker.getSlotValue(1);
			}

			if (this.areaName != picker.getSlotValue(2) &&picker.getSlotValue(2) != undefined) {
		        this.areaName = picker.getSlotValue(2);
	      	}
			
		}
	},
	created() {
		this.getCity2().then(res => {
			this.province = res.data.data;
			this.slots[0].values = this.province;
		})

		
	}
}
</script>

<style scoped lang="less">
.city {
	width: 100%;
	background: #fff;
	.btn {
		height: 4.5rem;
		line-height: 4.5rem;
		padding: 0 1.5rem;
		font-size: 1.5rem;
		border-bottom: 1px solid #d6d6d6;
	}
	.fl {
		float: left;
	}
	.fr {
		float: right;
	}
}
</style>
<style>
.mint-popup-bottom {
	width: 100%;
}
.city .picker-slot {
	text-align: center !important;
	flex: 1 1 33% !important;
	font-size: 0.15rem;
}
.city .picker-item.picker-selected {
	color: #0086fe;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/city.vue